/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Mahmudur Rahman Fahim's Portfolio",
  description:
    "A curious software engineer who is trying to make modern and wonderful projects and learn new things.",
  og: {
    title: "Mahmudur Rahman Fahim Portfolio",
    type: "website",
  },
};

//Home Page
const greeting = {
  title: "Mahmudur Rahman Fahim",
  logo_name: "Fahim",
  nickname: "Fundamental",
  subTitle:
    "A curious software engineer who is trying to make modern and wonderful projects and learn new things.",
  resumeLink:
    "https://drive.google.com/drive/u/0/folders/1_y9broy39EMiU7AlzCXG4dkYaj381sfQ",
  portfolio_repository: "https://github.com/Fah1m09/",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/Fah1m09",
  // linkedin: "https://www.linkedin.com/in/mrfahim09/",
  // gmail: "mahmudurfahim@gmail.com",
  // facebook: "https://www.facebook.com/Fah1m09/",

  {
    name: "Github",
    link: "https://github.com/Fah1m09",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mrfahim09/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "#",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:mahmudurfahim@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/Fah1m09/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using React-Redux",
        "⚡ Creating application backend in Php, SqlDatabase",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Adobe Photoshop",
          fontAwesomeClassname: "file-icons:adobe-photoshop",
          style: {
            color: "#31A8FF",
          },
        },
      ],
    },
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/mahmudurfahim",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "#",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Ahsanullah University of Science and Technology",
      subtitle: "BSC. in Computer Science & Engineering",
      logo_path: "iiitk_logo.png",
      alt_name: "AUST",
      duration: "2016 - 2021",
      descriptions: [
        "⚡ I studied Computer Science & Engineering subjects like C, Java, Python, Database, AI, Algorithm, Machine Learning, Computer Architecture, Networking etc.",
        "⚡ Apart from this, I have done courses on Angular, React, HTML & CSS and Full Stack Development.",
        "⚡ I was selected for ITEE Training Program.",
      ],
      website_link: "https://www.aust.edu/",
    },
    {
      title: "Dhaka City College",
      subtitle: "Science Group",
      logo_path: "dcc.png",
      alt_name: "DCC",
      duration: "2013 - 2015",
      descriptions: [
        "⚡ I studied Science subjects like Physics, Chemistry, Math, Biology, English.",
      ],
      website_link: "https://www.dhakacitycollege.edu.bd/",
    },
    {
      title: "Faizur Rahman Ideal Institue",
      subtitle: "Science Group",
      logo_path: "frii.png",
      alt_name: "FRII",
      duration: "2006 - 2013",
      descriptions: [
        "⚡ I studied Science subjects like Physics, Chemistry, Math, Biology, English.",
        "⚡ I stood 25th position in khilgaon board on JSC 2010 examination.",
        "⚡ I achieved 2nd price in Story Writing in 2012.",
        "⚡ Placed 3rd in my class in 2012.",
      ],
      website_link: "https://frii.edu.bd/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: " HTML5 - From Basics to Advanced level",
      subtitle: " EdYoda Digital University",
      logo_path: "udemy-logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-3975dbaa-ba63-49f1-a126-0af471647c4a/",
      alt_name: " EdYoda Digital University",
      color_code: "#8C151599",
    },
    {
      title: "Python Data Structures",
      subtitle: "University of Michigan",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://coursera.org/share/3187b9a9edcb6edd232d9bd6ac517090",
      alt_name: "University of Michigan",
      color_code: "#00000099",
    },
    {
      title: "Programming for Everybody (Getting Started with Python)",
      subtitle: "University of Michigan",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://coursera.org/share/075fd23f4bd973614f4a880ded6f24f9",
      alt_name: "University of Michigan",
      color_code: "#0C9D5899",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Volunteership",
  description:
    "I just finished my university and currently working on Rajanigandha International to gather some experiences.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer",
          company: "Rajanigandha International",
          company_url: "http://www.rajanibd.com/",
          logo_path: "rajanigondha.png",
          duration: "December 2020 - PRESENT",
          location: "Kakrail, Dhaka",
          description:
            "I am working on building some software for operating some medical equipment like Hematology Analyzer. I am also working on the company website.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Modern elegent responsive friendly websites.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "mrfkhoma.png",
    description:
      "I am active on some social media specially in Facebook. Feel free to contract me on these social media platforms (links are given below). I can help you with HTML, CSS, JS, React, C# specially in Computer Hardware related works.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I am a professional tech reviewer and I run a page and a website called Tech Accumulator. Here I mainly write about different types fo computer hardwares and tips.",
    link: "https://techaccumulator.blogspot.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Level-3, House 23, Sath Mosjid Housing, Mohammadpur, Dhaka 1207",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/S9p5UiP3A1Qsj3cM6",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+88 0177 977 8518",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
